module.exports = __webpack_public_path__ + "static/media/bank.ce9fc21f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/icons/bank.svg
 ** module id = 431
 ** module chunks = 0
 **/